import { formatDateTime, formatMoney, whatsappHref } from './formatters';

function lineItems(items = []) {
  return (Array.isArray(items) ? items : [])
    .map((item) => `- ${item.name} x${Number(item.qty || 1)}`)
    .join('\n');
}

function cleanLine(value, fallback = '—') {
  const text = String(value || '').trim();
  return text || fallback;
}

export function buildStoreHandoffMessage(order) {
  if (!order) return '';
  return [
    `*LINK STORE HANDOFF*`,
    `Order: ${cleanLine(order.orderNumber || order.id)}`,
    `Source: ${cleanLine(order.source)}`,
    `Created: ${cleanLine(formatDateTime(order.createdAt))}`,
    `Sent to store: ${cleanLine(formatDateTime(new Date()))}`,
    '',
    `Customer: ${cleanLine(order.customerName)}`,
    `Phone: ${cleanLine(order.customerPhone)}`,
    `Assigned store: ${cleanLine(order.store)}`,
    `Payment: ${cleanLine(order.paymentMethod)}`,
    `Order total: ${formatMoney(order.total)}`,
    '',
    `Address: ${cleanLine(order.address)}`,
    `Suburb: ${cleanLine(order.suburb)}`,
    '',
    `Items:\n${lineItems(order.items) || '- No items listed'}`,
    '',
    `Customer note: ${cleanLine(order.notes, 'None')}`,
    order.issueFlag ? 'Attention: issue already flagged on this order.' : null,
    '',
    'Please confirm stock, pack, and mark ready in Link.',
  ].filter(Boolean).join('\n');
}

export function getStoreWhatsAppHref(order, targetNumber = '') {
  return whatsappHref(targetNumber, buildStoreHandoffMessage(order));
}

export async function copyStoreHandoffMessage(order) {
  const text = buildStoreHandoffMessage(order);
  if (!text) return false;

  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (error) {
    console.error('[OnTime] clipboard write failed', error);
  }

  try {
    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', 'true');
    area.style.position = 'absolute';
    area.style.left = '-9999px';
    document.body.appendChild(area);
    area.select();
    document.execCommand('copy');
    document.body.removeChild(area);
    return true;
  } catch (error) {
    console.error('[OnTime] clipboard fallback failed', error);
    return false;
  }
}
